module.exports = __webpack_public_path__ + "static/media/Marowak_gaussian2.2b9d0f04.png";